import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { LaPosteEn4Type } from '../../../types/LaPosteEn4/page';
import { processSlices } from '../slices';
import laPosteEn4SliceMapper from '../slices/la-poste-en-4';
import { pageEntity } from './internal';

const processCustomSlices = processSlices(laPosteEn4SliceMapper);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processLaPosteEn4 = (entity: any): LaPosteEn4Type =>
  compact({
    uid: DocumentType.LA_POSTE_EN_4,
    type: DocumentType.LA_POSTE_EN_4,
    body: processCustomSlices(entity.data?.body_slices),
  });

const LaPosteEn4 = pageEntity<LaPosteEn4Type>(DocumentType.LA_POSTE_EN_4, {
  processStrategy: processLaPosteEn4,
});

export default LaPosteEn4;
